<div class="subtitle" *ngIf="!displayMessage">{{ subtitleWidget }}</div>
<div
    class="container-activity"
    *ngIf="requestState"
    [ngClass]="{ 'd-none': displayMessage }"
>
    <app-main-table
        class="drill-activity"
        [tableConfig]="tableConfig"
    ></app-main-table>
</div>
